module.exports = __webpack_public_path__ + "files/7e2ff19454f9f643d79c6f48019424b0.png";